const { CANCELLED, CLOSED, DRAFT, OPEN } = require("../consts/status");

const getStatusColor = (status) => {
    switch (status) {
      case OPEN:
        return 'border border-blue-200 !bg-blue-50 !text-blue-700';
      case DRAFT:
        return 'border border-gray-200 !bg-gray-100 !text-gray-700';
      case CANCELLED:
        return 'border border-red-200 !bg-red-50 !text-red-700';
      case CLOSED:
        return 'border border-emerald-200 !bg-emerald-50 !text-emerald-700';
      default:
        return 'border border-gray-200 !bg-gray-100 !text-gray-700';
    }
};

const getShippingMethodColor = (method) => {
  switch (method?.toLowerCase()) {
    case 'land':
      return 'bg-gray-100 text-gray-800';
    case 'sea':
      return 'bg-blue-100 text-blue-800';
    case 'air':
      return 'bg-indigo-100 text-indigo-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

exports.getStatusColor = getStatusColor
exports.getShippingMethodColor = getShippingMethodColor